export const MANAGE_GIVING_LINK_FORM_LINK_FIELD_PLACEHOLDER = 'manage-giving-link-form.link-field-placeholder';
export const MANAGE_GIVING_LINK_FORM_INVALID_URL_ERROR_MESSAGE = 'manage-giving-link-form.invalid-url-error-message';
export const MANAGE_GIVING_LINK_FORM_SUBMIT_BUTTON_LABEL = 'manage-giving-link-form.submit-button-label';
export const MANAGE_GIVING_LINK_FORM_CANCEL_BUTTON_LABEL = 'manage-giving-link-form.cancel-button-label';
